export default {
  'sendpasswordsuccessfully.sendpassword': 'Password Send Successfully',
  'sendpasswordsuccessfully.and': 'And',
  'sendpasswordsuccessfully.successfully': 'successfully',
  'sendpasswordsuccessfully.passwordsentto':
    'Send password recovery link to email ',
  'sendpasswordsuccessfully.checkemail':
    'Please check your email to reset your password',
};
